import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserBuildingStore } from '../user-building';

export const userBuildingPermissionLoadedGuard = (
    route: Pick<ActivatedRouteSnapshot, 'paramMap' | 'params'>
) => {
    const store = inject(UserBuildingStore);
    const router = inject(Router);
    const buildingId =
        route.paramMap.get('buildingId') ?? route.params['buildingId'] ?? '';
    return store.verifyForNavigation$(buildingId).pipe(
        map((decision) => {
            if (decision === 'granted') return true;
            if (decision === 'superseded' || decision === 'unauthenticated')
                return false;
            if (
                decision === 'unavailable' &&
                store.currentBuildingId() === buildingId &&
                store.buildingPermission()
            )
                return false;
            if (store.accessLost()) return router.createUrlTree(['/buildings']);
            return router.createUrlTree(['/buildings/access-unavailable'], {
                queryParams: { buildingId, reason: decision },
            });
        })
    );
};
